<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="CS943-Drucker">
     CS943-Drucker
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_de" title="Sicherheitshinweise">
     Sicherheitshinweise
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Konventionen">
      Konventionen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-power-cord-topic.html#d0e40" title="Produktaussagen">
      Produktaussagen
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learn-about-printer-chapter.html#learn-about-printer-chapter_de" title="Informationen zum Drucker">
     Informationen zum Drucker
    </a>
   </p>
   <div id="divd0e162">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_de" title="Suchen nach Informationen zum Drucker">
      Suchen nach Informationen zum Drucker
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_de" title="Ermitteln der Seriennummer des Druckers">
      Ermitteln der Seriennummer des Druckers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_de" title="Druckerkonfigurationen">
      Druckerkonfigurationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_de" title="Verwenden des Bedienfelds">
      Verwenden des Bedienfelds
     </a>
    </p>
    <p class="toc-2-style">
     <a href="understanding-status-of-power-button-and-indicator-light-topic.html#understanding-status-of-power-button-and-indicator-light_de" title="Bedeutung der Kontrollleuchtenstatus">
      Bedeutung der Kontrollleuchtenstatus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e553" title="Ausw&auml;hlen des Papiers">
      Ausw&auml;hlen des Papiers
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setup-install-and-configure-chapter.html#setup-install-and-configure-chapter_de" title="Einrichten, Installieren und Konfigurieren">
     Einrichten, Installieren und Konfigurieren
    </a>
   </p>
   <div id="divd0e5302">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_de" title="Auswahl eines Druckerstandorts">
      Auswahl eines Druckerstandorts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="attaching-cables-topic.html#attaching-cables_de" title="Anschlie&szlig;en der Kabel">
      Anschlie&szlig;en der Kabel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#d0e5480" title="Einrichten und Verwenden der Startbildschirm-Anwendungen">
      Einrichten und Verwenden der Startbildschirm-Anwendungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e5919" title="Einrichten und Verwenden der Barrierefreiheitsfunktionen">
      Einrichten und Verwenden der Barrierefreiheitsfunktionen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_de" title="Einlegen von Papier und Spezialdruckmedien">
      Einlegen von Papier und Spezialdruckmedien
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e6613" title="Installation und Aktualisierung der Software, Treiber und Firmware">
      Installation und Aktualisierung der Software, Treiber und Firmware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-envelope-tray-topic.html#d0e6873" title="Installieren von Hardwareoptionen">
      Installieren von Hardwareoptionen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="networking-intro-topic.html#d0e7856" title="Arbeiten im Netzwerk">
      Arbeiten im Netzwerk
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="secure-printer-chapter.html#secure-printer-chapter_de" title="Sichern des Druckers">
     Sichern des Druckers
    </a>
   </p>
   <div id="divd0e8246">
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_de" title="Ermitteln des Sicherheitssteckplatzes">
      Ermitteln des Sicherheitssteckplatzes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_de" title="L&ouml;schen des Druckerspeichers">
      L&ouml;schen des Druckerspeichers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_de" title="L&ouml;schen des Druckerspeichers">
      L&ouml;schen des Druckerspeichers
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_de" title="Wiederherstellen der Werkseinstellungen">
      Wiederherstellen der Werkseinstellungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_de" title="Hinweis zu fl&uuml;chtigem Speicher">
      Hinweis zu fl&uuml;chtigem Speicher
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="print-chapter.html#print-chapter_de" title="Print">
     Print
    </a>
   </p>
   <div id="divd0e8438">
    <p class="toc-2-style">
     <a href="printing-from-computer-h2-topic.html#printing-from-computer-h2_de" title="Von einem Computer aus drucken">
      Von einem Computer aus drucken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-topic.html#d0e8464" title="Drucken &uuml;ber ein Mobilger&auml;t">
      Drucken &uuml;ber ein Mobilger&auml;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-booklet-topic.html#printing-booklet_de" title="Drucken einer Brosch&uuml;re">
      Drucken einer Brosch&uuml;re
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_de" title="Drucken von einem Flash-Laufwerk">
      Drucken von einem Flash-Laufwerk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-flash-drives-and-file-types-topic.html#supported-flash-drives-and-file-types_de" title="Unterst&uuml;tzte Flash-Laufwerke und Dateitypen">
      Unterst&uuml;tzte Flash-Laufwerke und Dateitypen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_de" title="Konfigurieren vertraulicher Druckauftr&auml;ge">
      Konfigurieren vertraulicher Druckauftr&auml;ge
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_de" title="Drucken von vertraulichen und anderen angehaltenen Druckauftr&auml;gen">
      Drucken von vertraulichen und anderen angehaltenen Druckauftr&auml;gen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-h2-topic.html#printing-font-sample-list-h2_de" title="Drucken von Schriftartmusterlisten">
      Drucken von Schriftartmusterlisten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-h2-topic.html#printing-directory-list-h2_de" title="Drucken von Verzeichnislisten">
      Drucken von Verzeichnislisten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-topic.html#placing-separator-sheets_de" title="Einf&uuml;gen von Trennseiten zwischen Kopien">
      Einf&uuml;gen von Trennseiten zwischen Kopien
     </a>
    </p>
    <p class="toc-2-style">
     <a href="stapling-printed-sheets-topic.html#stapling-printed-sheets_de" title="Heften von Ausdrucken">
      Heften von Ausdrucken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="punching-holes-printed-sheets-topic.html#punching-holes-printed-sheets_de" title="Lochen von Ausdrucken">
      Lochen von Ausdrucken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="folding-printed-sheets-topic.html#folding-printed-sheets_de" title="Falten von Ausdrucken">
      Falten von Ausdrucken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacking-printed-sheets-topic.html#using-offset-stacking-printed-sheets_de" title="Verwenden von versetzter Stapelung f&uuml;r Ausdrucke">
      Verwenden von versetzter Stapelung f&uuml;r Ausdrucke
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_de" title="Abbrechen eines Druckauftrags">
      Abbrechen eines Druckauftrags
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_de" title="Anpassen des Tonerauftrags">
      Anpassen des Tonerauftrags
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="understanding-printer-menus-chapter.html#understanding-printer-menus-chapter_de" title="Verwenden der Druckermen&uuml;s">
     Verwenden der Druckermen&uuml;s
    </a>
   </p>
   <div id="divd0e9334">
    <p class="toc-2-style">
     <a href="menu-map-mfp-topic.html#menus-map-mfp_de" title="Men&uuml;zuordnung">
      Men&uuml;zuordnung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e9632" title="Ger&auml;t">
      Ger&auml;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e11465" title="Print">
      Print
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e12855" title="Papier">
      Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-print-topic.html#d0e13161" title="USB-Laufwerk">
      USB-Laufwerk
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e13466" title="Netzwerk/Anschl&uuml;sse">
      Netzwerk/Anschl&uuml;sse
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e15630" title="Sicherheit">
      Sicherheit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e16705" title="Clouddienste">
      Clouddienste
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e16762" title="Berichte">
      Berichte
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_de" title="Fehlerbehebung">
      Fehlerbehebung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_de" title="Drucken der Men&uuml;einstellungsseite">
      Drucken der Men&uuml;einstellungsseite
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_de" title="Wartung des Druckers">
     Wartung des Druckers
    </a>
   </p>
   <div id="divd0e16993">
    <p class="toc-2-style">
     <a href="checking-status-of-parts-and-supplies-topic.html#checking-status-of-parts-and-supplies_de" title="&Uuml;berpr&uuml;fen des Status der Druckerverbrauchsmaterialien und -teile">
      &Uuml;berpr&uuml;fen des Status der Druckerverbrauchsmaterialien und -teile
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_de" title="Materialbenachrichtigungen konfigurieren">
      Materialbenachrichtigungen konfigurieren
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-e-mail-alert-topic.html#setting-up-e-mail-alert_de" title="Einrichten von E-Mail-Benachrichtigungen">
      Einrichten von E-Mail-Benachrichtigungen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="viewing-reports-topic.html#viewing-reports_de" title="Anzeigen von Berichten">
      Anzeigen von Berichten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_de" title="Bestellen von Verbrauchsmaterialien und Teilen">
      Bestellen von Verbrauchsmaterialien und Teilen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e17243" title="Ersetzen von Verbrauchsmaterialien und Teilen">
      Ersetzen von Verbrauchsmaterialien und Teilen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e18118" title="Reinigen der Druckerteile">
      Reinigen der Druckerteile
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e18386" title="Sparen von Energie und Papier">
      Sparen von Energie und Papier
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_de" title="Umsetzen des Druckers an einen anderen Standort">
      Umsetzen des Druckers an einen anderen Standort
     </a>
    </p>
    <p class="toc-2-style">
     <a href="shipping-printer-topic.html#shipping-printer_de" title="Transportieren des Druckers">
      Transportieren des Druckers
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshoot-problem-chapter.html#troubleshoot-problem-chapter_de" title="Beheben eines Problems">
     Beheben eines Problems
    </a>
   </p>
   <div id="divd0e18541">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_de" title="Druckqualit&auml;tsprobleme">
      Druckqualit&auml;tsprobleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_de" title="Druckerfehlercodes">
      Druckerfehlercodes
     </a>
    </p>
    <p class="toc-2-style">
     <a href="print-quality-is-poor-subgroup.html#d0e19384" title="Druckprobleme">
      Druckprobleme
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_de" title="Der Drucker reagiert nicht">
      Der Drucker reagiert nicht
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_de" title="Flash-Laufwerk kann nicht gelesen werden">
      Flash-Laufwerk kann nicht gelesen werden
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_de" title="Aktivieren des USB-Anschlusses">
      Aktivieren des USB-Anschlusses
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_de" title="Beseitigen von Staus">
      Beseitigen von Staus
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e22511" title="Probleme mit der Netzwerkverbindung">
      Probleme mit der Netzwerkverbindung
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e22739" title="Probleme mit Hardwareoptionen">
      Probleme mit Hardwareoptionen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-missing-or-unresponsive-toner-cartridge-topic.html#d0e22994" title="Probleme mit Verbrauchsmaterial">
      Probleme mit Verbrauchsmaterial
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-envelope-seals-when-printing-topic.html#d0e23099" title="Probleme mit der Papierzufuhr">
      Probleme mit der Papierzufuhr
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e23465" title="Probleme mit der Farbqualit&auml;t">
      Probleme mit der Farbqualit&auml;t
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_de" title="Kontaktaufnahme mit dem Kundendienst">
      Kontaktaufnahme mit dem Kundendienst
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_de" title="Recyceln und Entsorgen">
     Recyceln und Entsorgen
    </a>
   </p>
   <div id="divd0e23715">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_de" title="Recycling von Lexmark Produkten">
      Recycling von Lexmark Produkten
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_de" title="Recycling der Verpackung von Lexmark">
      Recycling der Verpackung von Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_de" title="Hinweise">
     Hinweise
    </a>
   </p>
   <div id="divd0e23750">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23753" title="Produktinformationen">
      Produktinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23770" title="Hinweis zur Ausgabe">
      Hinweis zur Ausgabe
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_de" title="Marken">
      Marken
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_de" title="Lizenzhinweise">
      Lizenzhinweise
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#deutsche-kontaktinformationen_de" title="Deutsche Kontaktinformationen">
      Deutsche Kontaktinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_de" title="Ger&auml;uschemissionspegel">
      Ger&auml;uschemissionspegel
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_de" title="WEEE-Richtlinie (Waste from Electrical and Electronic Equipment = Elektronikschrott-Verordnung)">
      WEEE-Richtlinie (Waste from Electrical and Electronic Equipment = Elektronikschrott-Verordnung)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23903" title="Lithium-Ionen-Akku">
      Lithium-Ionen-Akku
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_de" title="Verordnung (EU) 2023/1542">
      Verordnung (EU) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e23941" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_de" title="Entsorgung des Produkts">
      Entsorgung des Produkts
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_de" title="R&uuml;ckgabe von Lexmark Kassetten zur Wiederverwendung oder zum Recycling">
      R&uuml;ckgabe von Lexmark Kassetten zur Wiederverwendung oder zum Recycling
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_de" title="Hinweis zur statischen Empfindlichkeit">
      Hinweis zur statischen Empfindlichkeit
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_de" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_de" title="Temperaturinformationen">
      Temperaturinformationen
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_de" title="Energieverbrauch">
      Energieverbrauch
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_de" title="&Uuml;bereinstimmung mit den Richtlinien der Europ&auml;ischen Gemeinschaft (EG)">
      &Uuml;bereinstimmung mit den Richtlinien der Europ&auml;ischen Gemeinschaft (EG)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_de" title="Hinweis zu St&ouml;rungen des Radio- und Fernsehempfangs">
      Hinweis zu St&ouml;rungen des Radio- und Fernsehempfangs
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue